import Heading from '../../components/Heading'
import Button from '../../components/Button'
import Card from '../../components/Card'
import React from 'react'
import { useAdmin } from '../../contexts/AdminContext'
import { useTranslation } from 'react-i18next'
import { showToast } from '../../services/ToastService'
import { useNavigate } from 'react-router-dom'

const CompanyBox: React.FC<{
    className: string | undefined
    edit: () => void
}> = ({ className, edit }) => {
    const { user, service, changeUser } = useAdmin()
    const navigate = useNavigate()
    const { t } = useTranslation(['settings'])
    const logout = () => {
        service
            .logout()
            .then(() => {
                service.setToken(null)
                showToast(t('subscription.logoutSuccessfully'))
                changeUser(null)
                navigate('/subscription')
            })
            .catch(() => {
                navigate('/subscription')
            })
    }

    return (
        <Card classes={className}>
            <Heading level={3}>{t('subscription.companyInformation')}</Heading>
            <p>
                <b>{t('subscription.companyName')}</b>
                <br />
                {user?.company}
            </p>
            <p>
                <b>{t('subscription.firstName')}</b>
                <br />
                {user?.firstname} {user?.lastname}
            </p>
            <p>
                <b>{t('subscription.street')}</b>
                <br />
                {user?.street}
            </p>
            <p>
                <b>PLZ, Ort</b>
                <br />
                {user?.zipcode} {user?.city}
            </p>
            <p>
                <b>{t('subscription.telephone')}</b>
                <br />
                {user?.phone}
            </p>
            <div className={'zr-d-flex zr-justify-between zr-items-center'}>
                <Button
                    hierarchy={'primary'}
                    text={t('subscription.adjustData')}
                    fn={() => edit()}
                />
                <Button
                    hierarchy={'tertiary'}
                    text={t('subscription.logout')}
                    fn={() => logout()}
                />
            </div>
        </Card>
    )
}

export default CompanyBox
